<template>
  <section
    data-qa="hero-section"
    class="hero-section"
  >
    <v-container class="ga-6 d-flex flex-column flex-md-row justify-md-space-between align-md-center">
      <div class="d-flex flex-column align-start">
        <h1 class="mb-2 mb-sm-6 text-ui-kit-text text-h4 text-sm-landing-h1 font-weight-bold">
          Личный кабинет пациента
        </h1>
        <p
          data-qa="hero-section-subtitle"
          class="mb-6 text-ui-kit-text text-body-1 text-sm-landing-h6"
        >
          с защищённой электронной
          медкартой<template v-if="locale.isRu">, которую легко показать любому врачу</template>
        </p>

        <div
          v-if="locale.isRu"
          class="mb-6 gc-10 gr-3 py-sm-9 d-flex flex-column flex-sm-row"
        >
          <div
            v-for="item in statisticsData"
            :key="item.name"
            :class="{
            }"
          >
            <div class="landing-card-title-1">
              {{ item.value }}
            </div>
            <div class="body-1 text-ui-kit-text-info">
              {{ item.name }}
            </div>
          </div>
        </div>

        <v-sheet
          data-qa="hero-section-qr-code"
          class="mt-5 pa-3 pr-3 d-md-flex d-none align-center hero-qr-code"
        >
          <v-img
            aspect-ratio="1"
            alt="qr код приложения"
            :src="locale.isCis ? '/images/qr-medtochka-cis.png' : '/images/qr-medtochka.png'"
            :height="146"
            :width="146"
            eager
          />
          <p class="ml-2 mb-0 px-2 text-landing-body-2 text-center">
            Отсканируйте<br />QR-код для загрузки<br />приложения
          </p>
          <v-sheet
            class="d-flex text-h4 rounded-pill hero-qr-code__rate align-center justify-center"
            width="110"
          >
            4,9
            <v-icon
              color="ui-kit-rating"
              class="ml-1"
              size="24"
            >
              ui-icon-rating-star-filled
            </v-icon>
          </v-sheet>
        </v-sheet>
        <div class="mb-6 d-md-none d-block">
          <BaseMtButton @click="handleDownloadButtonClick">
            Скачать приложение
          </BaseMtButton>
          <div class="mt-2 d-flex align-center">
            Средняя оценка
            <span class=" ml-2 d-flex align-center">
              <span class="text-subtitle-1">4,9</span> <v-icon
                color="ui-kit-rating"
                class="ml-1"
                size="20"
              >
                ui-icon-rating-star-filled
              </v-icon>
            </span>
          </div>
        </div>
      </div>

      <v-img
        class="px-6"
        min-width="304px"
        width="100%"
        max-width="592px"
        src="/images/hero-main.png"
        srcset="/images/hero-main.png 1x, /images/hero-main-2x.png 2x, /images/hero-main-3x.png 3x"
        alt="Главная страница приложения МедТочка"
        :aspect-ratio="1.22061856"
        contain
      />
    </v-container>
  </section>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { LINK_DOWNLOAD_MEDTOCHKA_APP } from '~/constants/links'
import type { Statistics } from '~/features/Home/api/homeApi'

const props = defineProps({
  statistics: { type: Object as PropType<Statistics | null>, default: null },
})

const locale = useAppLocale()

const statisticsData = computed(() => !props.statistics
  ? []
  : [
    {
      name: pluralize(props.statistics.patients, ['пользователь', 'пользователя', 'пользователей'], false),
      value: props.statistics.patients.toLocaleString('ru'),
    },
    {
      name: pluralize(props.statistics.patients_with_medcard, ['медкарта\xA0пациентов', 'медкарты\xA0пациентов', 'медкарт\xA0пациентов'], false),
      value: props.statistics.patients_with_medcard.toLocaleString('ru'),
    },
    {
      name: pluralize(props.statistics.medcard_course_medals, ['врач', 'врача', 'врачей'], false) + '\xA0работает с\xA0медкартой',
      value: props.statistics.medcard_course_medals.toLocaleString('ru'),
    },
  ])

function handleDownloadButtonClick() {
  window.location.assign(LINK_DOWNLOAD_MEDTOCHKA_APP)
}
</script>

<style lang="scss" scoped>
@use '@/assets/vuetify/settings';
@use 'sass:map';

.hero-section {
  margin-top: 24px;
  padding-bottom: 0;

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    margin-top: 72px;
    padding-bottom: 60px;
  }
}

.hero-qr-code {
  position: relative;
  border-radius: 12px;
  border: 2px solid $t-ui-bg-primary;
  margin-right: 20px;

  &__rate {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50px, -50%);
    border: 2px solid $t-ui-bg-primary;
  }
}
</style>
